export default function getQuantity(fields) {
  const defaultQuantity = 1;

  if (!fields) return defaultQuantity;

  const quantityField = Object.values(fields).find(
    field => field.element === 'quantity',
  );

  return quantityField?.value || defaultQuantity;
}
